// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69ee65c5","451":"0c06c665","455":"84b79d1e"}[chunkId] + ".chunk.js";
};